/* ============================================================================
   bk-thumb-sync.js — лента миниатюр едет за выбранным кадром.

   ЧТО БЫЛО. При смене варианта (цвет, размер) тема переводит главный слайдер
   на кадр варианта и вешает `thumb-active` на нужную миниатюру, но САМУ ленту
   `.thumbnails-wrapper` никто не двигает. У «Складной башни» это 32 миниатюры
   шириной 3608 px в окне 479 px: активной оказывается 18-я, она за краем, и на
   экране лента выглядит непереключившейся. Кода, который её прокручивал,
   в теме нет ни в одном из шести магазинов — прокрутку делал slick
   (`asNavFor` + `centerMode`), и его инициализация закомментирована.
   Проверено на живых витринах DE/FR/IT: scrollLeft остаётся 0, offsetLeft
   активной миниатюры — 1981…2094 px.

   ПОЧЕМУ НЕ ВЕРНУТЬ SLICK. Второй слайдер поверх галереи уже один раз сбил
   теме нумерацию слайдов (см. snippets/bk-set-fill.liquid): тема открывает
   кадр по `data-slick-index`, а slick на ленте эти индексы переписывает.
   Здесь хватает обычной прокрутки контейнера.

   КАК РАБОТАЕТ. Слушаем не событие слайдера, а класс `thumb-active` на
   миниатюрах: его ставит сама тема — и при смене варианта, и при клике по
   миниатюре, и при свайпе главного кадра. MutationObserver ловит любой из
   этих путей, не зная ни про slick, ни про jQuery, ни про вариант-пикер.

   Скрытые миниатюры (наборы BusySpace прячут чужие комплектации) пропускаем:
   у скрытой offsetParent === null, прокручивать к ней некуда.
   ============================================================================ */
(function () {
  function boot() {
    var wrapper = document.querySelector('.thumbnails-wrapper');
    if (!wrapper) return;

    /* Активная миниатюра встаёт вплотную к левому краю окна ленты.
       Считаем через getBoundingClientRect, а не offsetLeft: offsetLeft мерится
       от ближайшего позиционированного предка, а у ленты свои margin-left
       45/20 px — с ними арифметика по offsetLeft врёт на эту величину. */
    function reveal(el, smooth) {
      if (!el || el.offsetParent === null) return;
      var max = wrapper.scrollWidth - wrapper.clientWidth;
      if (max <= 0) return;
      var delta = el.getBoundingClientRect().left - wrapper.getBoundingClientRect().left;
      var left = Math.max(0, Math.min(wrapper.scrollLeft + delta, max));
      if (Math.abs(left - wrapper.scrollLeft) < 2) return;
      /* scroll-behavior у контейнера уже smooth; при первой отрисовке анимация
         не нужна — кадр должен просто оказаться на месте. */
      if (wrapper.scrollTo) wrapper.scrollTo({ left: left, behavior: smooth ? 'smooth' : 'auto' });
      else wrapper.scrollLeft = left;
    }

    var pending = null;
    function follow(smooth) {
      clearTimeout(pending);
      pending = setTimeout(function () {
        reveal(wrapper.querySelector('.thumbnail-item.thumb-active'), smooth);
      }, 0);
    }

    if (window.MutationObserver) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var t = muts[i].target;
          if (t.classList && t.classList.contains('thumb-active')) { follow(true); return; }
        }
      }).observe(wrapper, { subtree: true, attributes: true, attributeFilter: ['class'] });
    }

    /* Первый кадр: с ?variant=… тема открывает середину галереи, а лента
       по-прежнему в нуле. Класс к этому моменту может быть ещё не проставлен —
       отсюда две попытки, обе без анимации. */
    follow(false);
    addEventListener('load', function () { setTimeout(function () { follow(false); }, 300); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
